<template>
  <div id="authPage">
    <base-nav
      v-model="showMenu"
      type="light"
      :transparent="true"
      menu-classes="justify-content-end"
      class="navbar-horizontal navbar-main"
      expand="sm"
    >
      <div slot="brand" class="navbar-wrapper">
        <b-navbar-brand to="/">
          <img src="/img/brand/claritynow-icon-color.png" class="mr-1"> ClarityNOW
        </b-navbar-brand>
      </div>

     <template>
       <div class="navbar-collapse-header">
         <b-row>
           <b-col cols="6" class="collapse-brand">
             <router-link to="/">
               <img src="img/brand/clarity-logo-white.png">
             </router-link>
           </b-col>
           <b-col cols="6" class="collapse-close">
             <button type="button" class="navbar-toggler text-dark" @click="showMenu = false">
               <span></span>
               <span></span>
             </button>
           </b-col>
         </b-row>
       </div>

       <b-navbar-nav class="mr-auto">
         <!-- <b-nav-item to="/demo">
             <span class="nav-link-inner--text" v-if="!authenticated">Demo</span>
         </b-nav-item> -->
         <b-nav-item to="/" >
             <span class="nav-link-inner--text" v-if="!authenticated">Login</span>
         </b-nav-item>
       </b-navbar-nav>
       <hr class="d-lg-none">
       <b-navbar-nav  class="align-items-lg-center ml-lg-auto">
         <b-nav-item link-classes="nav-link-icon text-dark" href="https://www.facebook.com/ClarityNOWRE" target="_blank"
              data-toggle="tooltip" data-original-title="Like us on Facebook" >
             <i class="fab fa-facebook-square"></i>
             <span class="nav-link-inner--text d-lg-none">Facebook</span>
         </b-nav-item>
         <b-nav-item link-classes="nav-link-icon text-dark" href="https://www.instagram.com/claritynowre" target="_blank" data-toggle="tooltip" data-original-title="Follow us on Instagram">
             <i class="fab fa-instagram"></i>
             <span class="nav-link-inner--text d-lg-none">Instagram</span>
         </b-nav-item>
         <b-nav-item link-classes="nav-link-icon text-dark" href="https://www.linkedin.com/company/claritynowre/" target="_blank" data-toggle="tooltip" data-original-title="Follow us on LinkedIn">
             <i class="fab fa-linkedin"></i>
             <span class="nav-link-inner--text d-lg-none">LinkedIn</span>
         </b-nav-item>
         <!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
         <li class="nav-item d-none d-lg-block ml-lg-4" v-if="!authenticated">
           <a href="/register" target="_blank"
              class="btn btn-danger btn-icon">
             <span class="nav-link-inner--text">Sign Up Now</span>
           </a>
         </li>
         <base-dropdown menu-on-right
                        class="nav-item"
                        tag="li"
                        title-tag="a"
                        title-classes="nav-link pr-0" v-else>
           <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
             <b-media no-body class="align-items-center">
                     <span class="avatar avatar-sm rounded-circle">
                       <img alt="Image placeholder" src="/img/theme/default-avatar.jpg">
                     </span>
               <b-media-body class="ml-2 d-none d-lg-block">
                 <span class="mb-0 text-sm  font-weight-bold">{{ user.name }}</span>
               </b-media-body>
             </b-media>
           </a>

           <template>

             <b-dropdown-header class="noti-title">
               <h6 class="text-overflow m-0">Welcome!</h6>
             </b-dropdown-header>
             <b-dropdown-item @click="goToAccount">
               <i class="fas fa-cog"></i>
               <span>Account Settings</span>
             </b-dropdown-item>
             <div class="dropdown-divider"></div>
             <b-dropdown-item @click.prevent="logout()">
               <i class="ni ni-user-run"></i>
               <span>Logout</span>
             </b-dropdown-item>

           </template>
         </base-dropdown>
       </b-navbar-nav>
     </template>
    </base-nav>

    <div class="main-content">
      <zoom-center-transition
        :duration="pageTransitionDuration"
        mode="out-in"
      >
        <router-view></router-view>
      </zoom-center-transition>
    </div>

    <footer class="py-5 bg-white mt-7" id="footer-main">
      <b-container >
        <b-row align-v="center" class="justify-content-xl-between">
          <b-col xl="6">
            <div class="copyright text-center text-xl-left">
              © {{year}} <a href="https://www.claritynowre.com" class="font-weight-bold ml-1" target="_blank">ClarityNOW, Inc</a>
            </div>
          </b-col>
          <b-col xl="6" class="col-xl-6">
            <b-nav class="nav-footer justify-content-center justify-content-xl-end">
              <b-nav-item href="https://www.claritynowre.com" target="_blank">
                ClarityNOW, Inc
              </b-nav-item>
              <b-nav-item href="https://www.claritynowre.com" target="_blank">
               About Us
              </b-nav-item>
              <b-nav-item href="https://www.claritynowre.com/privacy-policy" target="_blank">
                Privacy
              </b-nav-item>
              <b-nav-item href="https://www.claritynowre.com/terms-and-conditions" target="_blank">
                Terms
              </b-nav-item>
            </b-nav>
          </b-col>
        </b-row>
      </b-container>
    </footer>
  </div>
</template>
<script>
  import axios from 'axios';
  import { BaseNav } from '@/components';
  import { ZoomCenterTransition } from 'vue2-transitions';

  export default {
    components: {
      BaseNav,
      ZoomCenterTransition
    },
    props: {
      backgroundColor: {
        type: String,
        default: 'black'
      }
    },
    data() {
      return {
        showMenu: false,
        menuTransitionDuration: 250,
        pageTransitionDuration: 200,
        year: new Date().getFullYear(),
        pageClass: 'login-page'
      };
    },
    computed: {
      title() {
        return `${this.$route.name} Page`;
      },
      user() {
        return this.$store.getters['profile/user'];
      },
      authenticated() {
        return this.$store.getters['isAuthenticated'];
      }
    },
    methods: {
      toggleNavbar() {
        document.body.classList.toggle('nav-open');
        this.showMenu = !this.showMenu;
      },
      closeMenu() {
        document.body.classList.remove('nav-open');
        this.showMenu = false;
      },
      setBackgroundColor() {
        document.body.classList.add('bg-secondary');
      },
      removeBackgroundColor() {
        document.body.classList.remove('bg-secondary');
      },
      updateBackground() {
        if (!this.$route.meta.noBodyBackground) {
          this.setBackgroundColor();
        } else {
          this.removeBackgroundColor()
        }
      },
      async logout() {
        axios.post(process.env.VUE_APP_API_BASE_URL + "/logout")
        .then(response => {
          if(response.status == 200) {
            this.$store.dispatch("logout", {email: this.userEmail});
          }
        })
        .catch(error => {

        });
      },
      goToAccount() {
        if(this.$route.name !== 'Account') {
          this.$router.push({
            path: '/account-settings'
          });
        }
      },
    },
    beforeDestroy() {
      this.removeBackgroundColor();
    },
    beforeRouteUpdate(to, from, next) {
      // Close the mobile menu first then transition to next page
      if (this.showMenu) {
        this.closeMenu();
        setTimeout(() => {
          next();
        }, this.menuTransitionDuration);
      } else {
        next();
      }
    },
    watch: {
      $route: {
        immediate: true,
        handler: function () {
          this.updateBackground()
        }
      }
    }
  };
</script>
<style lang="scss">
  $scaleSize: 0.8;
  @keyframes zoomIn8 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    100% {
      opacity: 1;
    }
  }

  .main-content .zoomIn {
    animation-name: zoomIn8;
  }

  @keyframes zoomOut8 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }

  .main-content .zoomOut {
    animation-name: zoomOut8;
  }

  #authPage .navbar .container {
    background-color: #ffffff;
    box-shadow: 5px #000000;
    padding: .75rem;
    margin-top: 10px;
    border-radius: 10px;

    .navbar-brand {
      color: #000000 !important;
    }
  }

  .navbar-horizontal.navbar-transparent .navbar-toggler {
    color: #000000 !important;
  }
</style>
